import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import { getClassDetails, getClassStudents, getSubjectList, getClassTeachers } from "../../../redux/sclassRelated/sclassHandle";
import { deleteUser } from '../../../redux/userRelated/userHandle';
import {
    Box, Container, Typography, Tab, IconButton, Paper, Card, CardContent, Grid, Chip, Divider, Avatar, CircularProgress
} from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { resetSubjects } from "../../../redux/sclassRelated/sclassSlice";
import { BlueButton, GreenButton, PurpleButton } from "../../../components/buttonStyles";
import TableTemplate from "../../../components/TableTemplate";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { useToast } from "../../../context/ToastContext";
import DeleteIcon from "@mui/icons-material/Delete";
import PostAddIcon from '@mui/icons-material/PostAdd';
import GroupIcon from '@mui/icons-material/Group';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VisibilityIcon from '@mui/icons-material/Visibility';
import styled, { keyframes } from 'styled-components';

const ClassDetails = () => {
    const params = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { subjectsList, sclassStudents, sclassDetails, sclassTeachers, loading, error, response, getresponse } = useSelector((state) => state.sclass);
    const { showToast } = useToast();

    const classID = params.id

    useEffect(() => {
        dispatch(getClassDetails(classID, "Sclass"));
        dispatch(getSubjectList(classID, "ClassSubjects"))
        dispatch(getClassStudents(classID));
        dispatch(getClassTeachers(classID));
    }, [dispatch, classID])

    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

 
    const deleteHandler = (deleteID, address) => {
        showToast("Sorry, the delete function has been disabled for now.", "info")
    }

    const subjectColumns = [
        { id: 'name', label: 'Subject Name', minWidth: 170 },
        { id: 'code', label: 'Subject Code', minWidth: 100 },
        { id: 'sessions', label: 'Sessions', minWidth: 100 },
    ]

    const subjectRows = subjectsList && subjectsList.length > 0 && subjectsList.map((subject) => {
        return {
            name: subject.subName,
            code: subject.subCode,
            sessions: subject.sessions || 'N/A',
            id: subject._id,
        };
    })

    const SubjectsButtonHaver = ({ row }) => {
        return (
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                <IconButton 
                    onClick={() => navigate(`/Admin/class/subject/${classID}/${row.id}`)}
                    title="View Subject"
                    sx={{ bgcolor: '#e3f2fd', '&:hover': { bgcolor: '#bbdefb' } }}
                    size="small"
                >
                    <VisibilityIcon color="primary" fontSize="small" />
                </IconButton>
                <IconButton 
                    onClick={() => deleteHandler(row.id, "Subject")}
                    title="Delete Subject"
                    sx={{ bgcolor: '#ffebee', '&:hover': { bgcolor: '#ffcdd2' } }}
                    size="small"
                >
                    <DeleteIcon color="error" fontSize="small" />
                </IconButton>
            </Box>
        );
    };

    const studentColumns = [
        { id: 'photo', label: 'Photo', minWidth: 80 },
        { id: 'name', label: 'Name', minWidth: 170 },
        { id: 'rollNum', label: 'Roll No.', minWidth: 100 },
        { id: 'email', label: 'Email', minWidth: 150 },
        { id: 'phone', label: 'Phone', minWidth: 120 },
        { id: 'dob', label: 'DOB', minWidth: 120 },
        { id: 'address', label: 'Address', minWidth: 150 },
    ]

    const studentRows = sclassStudents.map((student) => {
        return {
            photo: student.photo,
            name: student.name,
            rollNum: student.rollNum,
            email: student.email || 'N/A',
            phone: student.phone || 'N/A',
            dob: student.dob ? new Date(student.dob).toLocaleDateString() : 'N/A',
            address: student.address || 'N/A',
            id: student._id,
        };
    })

    const StudentsButtonHaver = ({ row }) => {
        return (
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                <IconButton 
                    onClick={() => navigate("/Admin/students/student/" + row.id)}
                    title="View Student"
                    sx={{ bgcolor: '#e3f2fd', '&:hover': { bgcolor: '#bbdefb' } }}
                    size="small"
                >
                    <VisibilityIcon color="primary" fontSize="small" />
                </IconButton>
                <IconButton 
                    onClick={() => deleteHandler(row.id, "Student")}
                    title="Delete Student"
                    sx={{ bgcolor: '#ffebee', '&:hover': { bgcolor: '#ffcdd2' } }}
                    size="small"
                >
                    <PersonRemoveIcon color="error" fontSize="small" />
                </IconButton>
            </Box>
        );
    };

    const teacherColumns = [
        { id: 'name', label: 'Teacher Name', minWidth: 170 },
        { id: 'email', label: 'Email', minWidth: 200 },
        { id: 'subject', label: 'Subject', minWidth: 150 },
        { id: 'subCode', label: 'Subject Code', minWidth: 100 },
    ]

    const teacherRows = sclassTeachers.map((teacher) => {
        return {
            name: teacher.teacherName,
            email: teacher.teacherEmail,
            subject: teacher.subjectName,
            subCode: teacher.subjectCode || 'N/A',
            id: teacher._id,
        };
    })

    const TeachersButtonHaver = ({ row }) => {
        return (
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                <IconButton 
                    onClick={() => navigate(`/Admin/teachers/teacher/${row.id}`)}
                    title="View Teacher"
                    sx={{ bgcolor: '#e3f2fd', '&:hover': { bgcolor: '#bbdefb' } }}
                    size="small"
                >
                    <VisibilityIcon color="primary" fontSize="small" />
                </IconButton>
            </Box>
        );
    };

    const ClassSubjectsSection = () => {
        return (
            <SectionCard elevation={2}>
                <SectionHeader>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Subjects</Typography>
                        <Typography variant="body2" color="textSecondary">{subjectsList.length} subjects in this class</Typography>
                    </Box>
                    <GreenButton
                        variant="contained"
                        onClick={() => navigate("/Admin/addsubject/" + classID)}
                        startIcon={<PostAddIcon />}
                    >
                        Add Subjects
                    </GreenButton>
                </SectionHeader>
                <Divider sx={{ mb: 2 }} />
                {response ? (
                    <EmptyState>
                        <MenuBookIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
                        <Typography color="textSecondary">No subjects found for this class.</Typography>
                    </EmptyState>
                ) : (
                    <TableTemplate buttonHaver={SubjectsButtonHaver} columns={subjectColumns} rows={subjectRows} />
                )}
            </SectionCard>
        )
    }

    const ClassStudentsSection = () => {
        return (
            <SectionCard elevation={2}>
                <SectionHeader>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Students</Typography>
                        <Typography variant="body2" color="textSecondary">{sclassStudents.length} students enrolled</Typography>
                    </Box>
                    <GreenButton
                        variant="contained"
                        onClick={() => navigate("/Admin/class/addstudents/" + classID)}
                        startIcon={<PersonAddAlt1Icon />}
                    >
                        Add Students
                    </GreenButton>
                </SectionHeader>
                <Divider sx={{ mb: 2 }} />
                {getresponse ? (
                    <EmptyState>
                        <PeopleIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
                        <Typography color="textSecondary">No students found for this class.</Typography>
                    </EmptyState>
                ) : (
                    <TableTemplate buttonHaver={StudentsButtonHaver} columns={studentColumns} rows={studentRows} />
                )}
            </SectionCard>
        )
    }

    const ClassTeachersSection = () => {
        return (
            <SectionCard elevation={2}>
                <SectionHeader>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>Teachers</Typography>
                        <Typography variant="body2" color="textSecondary">{sclassTeachers.length} teachers assigned</Typography>
                    </Box> 
                </SectionHeader>
                <Divider sx={{ mb: 2 }} />
                {sclassTeachers && sclassTeachers.length > 0 ? (
                    <TableTemplate buttonHaver={TeachersButtonHaver} columns={teacherColumns} rows={teacherRows} />
                ) : (
                    <EmptyState>
                        <PersonIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
                        <Typography color="textSecondary">No teachers assigned to this class yet.</Typography>
                    </EmptyState>
                )}
            </SectionCard>
        )
    }

    const ClassDetailsSection = () => {
        const stats = [
            { label: 'Subjects', value: subjectsList.length, icon: <MenuBookIcon />, color: '#667eea', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
            { label: 'Students', value: sclassStudents.length, icon: <PeopleIcon />, color: '#11998e', gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)' },
            { label: 'Teachers', value: sclassTeachers.length, icon: <PersonIcon />, color: '#f093fb', gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
        ];

        return (
            <FadeInBox>
                <Grid container spacing={3}>
                    {stats.map((stat, index) => (
                        <Grid item xs={12} sm={4} key={index}>
                            <StatCard elevation={3} sx={{ background: stat.gradient }}>
                                <StatIconWrapper>
                                    {stat.icon}
                                </StatIconWrapper>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Typography variant="h6" sx={{ opacity: 0.8, fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: 1 }}>
                                        {stat.label}
                                    </Typography>
                                    <Typography variant="h3" sx={{ fontWeight: 800 }}>
                                        {stat.value}
                                    </Typography>
                                </Box>
                            </StatCard>
                        </Grid>
                    ))}
                    
                    <Grid item xs={12}>
                        <InfoPaper elevation={2}>
                            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <SchoolIcon color="primary" /> Class Information
                            </Typography>
                            <Divider sx={{ mb: 3 }} />
                            <Grid container spacing={4}>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase', fontWeight: 600 }}>Class Name</Typography>
                                        <Typography variant="h6" sx={{ color: '#1a1a2e' }}>{sclassDetails?.sclassName}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase', fontWeight: 600 }}>Class ID</Typography>
                                        <Typography variant="body1">{classID}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase', fontWeight: 600 }}>Status</Typography>
                                        <Box sx={{ mt: 0.5 }}>
                                            <Chip label="Active" color="success" size="small" />
                                        </Box>
                                    </Box>
                                    
                                </Grid>
                            </Grid>
                        </InfoPaper>
                    </Grid>
                </Grid>
            </FadeInBox>
        );
    }

    if (loading) {
        return (
            <LoadingWrapper>
                <CircularProgress size={60} />
                <Typography sx={{ mt: 2, color: '#667eea', fontWeight: 600 }}>Loading Class Details...</Typography>
            </LoadingWrapper>
        );
    }

    return (
        <PageContainer>
            <TabContext value={value}>
                <StickyHeader elevation={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', px: 2, pt: 1 }}>
                        <IconButton
                            onClick={() => navigate("/Admin/classes")}
                            sx={{ color: 'white', mr: 2, '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                Class {sclassDetails?.sclassName} Details
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                                Academic Year 2024-25
                            </Typography>
                        </Box>
                    </Box>
                    <TabList
                        onChange={handleChange}
                        variant="fullWidth"
                        sx={{
                            '& .MuiTab-root': { py: 2, fontWeight: 600, textTransform: 'none', color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem' },
                            '& .Mui-selected': { color: '#a78bfa !important' },
                            '& .MuiTabs-indicator': { backgroundColor: '#a78bfa', height: 3 },
                        }}
                    >
                        <Tab icon={<SchoolIcon />} iconPosition="start" label="Overview" value="1" />
                        <Tab icon={<MenuBookIcon />} iconPosition="start" label="Subjects" value="2" />
                        <Tab icon={<PeopleIcon />} iconPosition="start" label="Students" value="3" />
                        <Tab icon={<PersonIcon />} iconPosition="start" label="Teachers" value="4" />
                    </TabList>
                </StickyHeader>

                <MainContent maxWidth="xl">
                    <TabPanel value="1" sx={{ p: 0 }}><ClassDetailsSection /></TabPanel>
                    <TabPanel value="2" sx={{ p: 0 }}><ClassSubjectsSection /></TabPanel>
                    <TabPanel value="3" sx={{ p: 0 }}><ClassStudentsSection /></TabPanel>
                    <TabPanel value="4" sx={{ p: 0 }}><ClassTeachersSection /></TabPanel>
                </MainContent>
            </TabContext>
        </PageContainer>
    );
};

export default ClassDetails;

// Styled Components
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const PageContainer = styled.div`
    background-color: #f0f2f5;
    min-height: 100vh;
`;

const FadeInBox = styled(Box)`
  animation: ${fadeIn} 0.5s ease-out;
`;

const StickyHeader = styled(Paper)`
    position: sticky;
    top: 0;
    z-index: 1000;
    border-radius: 0 !important;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%) !important;
    color: white !important;
`;

const MainContent = styled(Container)`
    padding-top: 32px;
    padding-bottom: 40px;
`;

const StatCard = styled(Paper)`
    padding: 24px;
    border-radius: 20px !important;
    color: white !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: transform 0.3s ease;
    &:hover {
        transform: translateY(-5px);
    }
`;

const StatIconWrapper = styled(Box)`
    background: rgba(255, 255, 255, 0.2);
    width: 60px;
    height: 60px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        font-size: 32px;
    }
`;

const InfoPaper = styled(Paper)`
    padding: 32px;
    border-radius: 20px !important;
    background: white;
`;

const SectionCard = styled(Paper)`
    padding: 24px;
    border-radius: 20px !important;
    background: white;
    animation: ${fadeIn} 0.5s ease-out;
`;

const SectionHeader = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 16px;
`;

const EmptyState = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
`;

const LoadingWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80vh;
`;